import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, 
  CCard, CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import ShipmentInputs from '../../components/ShipmentInputs/ShipmentInputs';
import { addShipmentRequest } from '../../store/shipment/shipmentActions';

const CreateShipment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.shipmentReducer.isLoading);
  const submitResponse = useSelector(state => state.shipmentReducer.addShipmentData);

  const handleSubmit = (data) => {
    dispatch(addShipmentRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/shipments');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/shipments" 
        onClick={e => { e.preventDefault(); handleCancel(); }}>{t('shipments')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createShipment')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createShipment')}</h4></CCardHeader>
            <CCardBody>
              <ShipmentInputs onSubmit={handleSubmit}
               onCancel={handleCancel} isLoading={isLoading} 
               submitResponse={submitResponse} />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default CreateShipment; 